import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import MuiTypography from "@mui/material/Typography";
import classNames from "classnames";
export const Typography = props => {
  const {
    className,
    ...otherProps
  } = props;
  return /*#__PURE__*/React.createElement(MuiTypography, _extends({
    className: classNames(className, "prmbl-typography")
  }, otherProps));
};
Typography.defaultProps = {
  align: "inherit",
  gutterBottom: false,
  noWrap: false,
  paragraph: false,
  variant: "body1"
};
export default Typography;